var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"app-breadcrumb",attrs:{"separator":"/"}},[_c('transition-group',{attrs:{"name":"breadcrumb"}},_vm._l((_vm.levelList),function(item,index){return (item.meta.title)?_c('el-breadcrumb-item',{key:item.path},[(item.redirect === 'noredirect' || index == _vm.levelList.length - 1)?_c('span',{staticClass:"no-redirect"},[_vm._v(_vm._s(_vm.whichLang() === "thai"
            ? item.meta.titleFrCa
            : _vm.whichLang() === "zh"
            ? item.meta.title
            : item.meta.titleEnUs))]):_c('span',[_vm._v(_vm._s(_vm.whichLang() === "thai"
          ? item.meta.titleFrCa
          : _vm.whichLang() === "zh"
          ? item.meta.title
          : item.meta.titleEnUs))])]):_vm._e()}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-898022b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb/index.vue
// module id = null
// module chunks = 